import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class JobCostingService extends GenericService {
  constructor() {
    super('/job_costings', axiosInstance);
  }

  async getCostedOrder(costingId) {
    try {
      const response = await axiosInstance.get(`${this.baseUrl}/${this.encodePathSegment(costingId)}/costed_order`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async pushCloud(jobCostingId, payload = {}) {
    try {
      const response = await axiosInstance.post(
        `${this.baseUrl}/${this.encodePathSegment(jobCostingId)}/cloud/push`,
        payload
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new JobCostingService(); 